import { p as proxyCustomElement, H, h, c as Host } from './p-DUAwwEEc.js';
import { r as removeSSRSlot } from './p-CmCPGxtg.js';
import { d as defineCustomElement$4 } from './p-BVcGBUOP.js';
import { d as defineCustomElement$3 } from './p-eFHPLBHY.js';
import { d as defineCustomElement$2 } from './p-B6mCWWEr.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.4.1
 */

let sidenavMenuId = 0;
const Sidenav = /*@__PURE__*/ proxyCustomElement(class Sidenav extends H {
    constructor() {
        super();
        this.__registerHost();
        this.sidenavMenuId = `tds-sidenav-menu-${sidenavMenuId++}`;
        /**
         * The label for the sidenav, used for accessibility.
         */
        this.label = "Secondary";
    }
    // --------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    // --------------------------------------------------------------------------
    componentDidLoad() {
        removeSSRSlot(this.el);
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: 'df5140bd803a45f84daeb5292aaf30d3f35e786f', class: "tds-sidenav" }, h("nav", { key: '62b38d49339991483d3681e0d50925c441577695', id: this.sidenavMenuId, class: "tds-sidenav-nav", "aria-label": this.label }, h("tds-sidenav-responsive-header", { key: 'bd034449daf870d79ca6460e34edd245b8a2dee5', label: this.selectedItemLabel }), h("tds-sidenav-popover", { key: '5b1e84af4214a4f22facaca6b34bd6ce9e2238a2' }, h("slot", { key: '022ebd33093102cb8702490a008e0e37ed6e823f' })))));
    }
    get el() { return this; }
}, [6, "tds-sidenav", {
        "label": [1],
        "selectedItemLabel": [1, "selected-item-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav", "tds-popover-container", "tds-sidenav-popover", "tds-sidenav-responsive-header"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, Sidenav);
            }
            break;
        case "tds-popover-container":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "tds-sidenav-popover":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "tds-sidenav-responsive-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
const defineCustomElement = defineCustomElement$1;

export { defineCustomElement };
//# sourceMappingURL=tds-sidenav.js.map
